export default __webpack_public_path__ + "static/media/pic5.70d10705.png";